import React from 'react'
import VehiclesListContainer from './VehiclesListContainer'

const VehiclesList = props => (
  <VehiclesListContainer data-test="component-stock-vehicle-list" {...props} />
)
export default VehiclesList
